import entityReducer from "./requiredAttachmentEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
